import { typeCreatorV2 } from '../../../redux/utils/common';

export const SET_SEGMENTS: string = typeCreatorV2(
  'CategoryEditReducer',
  'SetSegments'
);

export const SET_CUSTOMERS: string = typeCreatorV2(
  'CategoryEditReducer',
  'SetCustomers'
);

export const SET_AGENTS: string = typeCreatorV2(
  'CategoryEditReducer',
  'SetAgents'
);

export const SET_CATEGORY_BASIC_INFO: string = typeCreatorV2(
  'CategoryEditReducer',
  'SetCategoryBasicInfo'
);

export const UPDATE_CATEGORY_BASIC_INFO: string = typeCreatorV2(
  'CategoryEditReducer',
  'UpdateCategoryBasicInfo'
);

export const UPDATE_DESCRIPTION_TEMPORARY: string = typeCreatorV2(
  'CategoryEditReducer',
  'UpdateDescriptionTemporary'
);

export const UPDATE_NAME_TEMPORARY: string = typeCreatorV2(
  'CategoryEditReducer',
  'UpdateNameTemporary'
);

export const SET_CATEGORY_LIST: string = typeCreatorV2(
  'CategoryEditReducer',
  'SetCategoryList'
);
